import { createSlice } from '@reduxjs/toolkit';
import {
  fetchOutreachById,
  fetchOutreachByIdInBackground,
  fetchOutreachCandidates,
  updateOutreachSettingsDispatch,
} from './actions';

const initialState = {
  isLoading: true,
  data: {},
  error: '',

  candidatePagination: {
    page: 1,
    items: 30,
  },

  filters: {
    changed: false,
    stages: [],
    step: [],
    sourcedBy: [],
    tags: [],
  },

  search: {
    term: null,
  },

  sort: {
    element: 'candidate_name',
    order: 'ASC',
  },
};

const { reducer, actions } = createSlice({
  name: 'outreach',
  initialState,

  reducers: {
    applyStep: (state, { payload: { step } }) => {
      state.filters.step = [...state.filters.step, step];
    },

    removeStep: (state, { payload: { step } }) => {
      state.filters.step = state.filters.step?.filter(
        (currStep) => currStep?.id !== step?.id
      );
    },

    applyFilter: (state, { payload }) => {
      const { type, value, selected } = payload;
      if (value?.length || value) {
        state.filters[type] = value;
      } else {
        state.filters[type] = selected;
      }
      state.filters.changed = true;
      state.candidatePagination.page = 1;
    },

    clearFilter: (state, { payload }) => {
      const { type, isMulti = false } = payload;
      state.filters[type] = isMulti ? [] : null;
    },

    resetFilter: (state) => {
      state.filters = { ...initialState?.filters, changed: false };
      state.candidatePagination.page = 1;
    },

    applySort: (state, { payload }) => {
      const { element, order } = payload;
      state.sort.element = element;
      state.sort.order = order;
    },

    applyPage: (state, { payload }) => {
      const { page } = payload;
      state.candidatePagination.page = page;
    },

    applySearchTerm: (state, { payload }) => {
      const { searchTerm } = payload;
      state.search.term = searchTerm;
    },

    addOutreachStep: (state, action) => {
      const { data: outreach } = state;
      const { data: newOutreachStep } = action.payload;
      const updatedSteps = outreach?.steps?.length
        ? [...outreach.steps, newOutreachStep]
        : [newOutreachStep];
      outreach.steps = updatedSteps;
      state.data = outreach;
    },
  },

  extraReducers: {
    [fetchOutreachById.pending]: (state, { meta }) => {
      const {
        arg: { background = false },
      } = meta;
      if (background) return;
      state.isLoading = true;
    },
    [fetchOutreachById.fulfilled]: (state, { payload }) => {
      if (payload?.data?.id) {
        state.data = payload?.data;
        state.error = '';
      } else {
        state.error = payload?.errors[0];
        state.data = {};
      }
      state.isLoading = false;
    },

    [fetchOutreachByIdInBackground.fulfilled]: (state, { payload }) => {
      state.data = payload?.data || {};
    },

    [updateOutreachSettingsDispatch.fulfilled]: (state, { payload }) => {
      const { errors, data = {} } = payload;
      if (errors?.title?.length) {
        return;
      }
      state.data = data || {};
    },

    [fetchOutreachCandidates.pending]: (state) => {
      state.isCandidatesLoading = true;
    },

    [fetchOutreachCandidates.fulfilled]: (state, { payload }) => {
      state.candidates = payload?.data?.candidates || {};
      state.candidatesStats = payload?.data?.step_stats || [];
      state.candidateMeta = payload?.meta || {};

      state.isCandidatesLoading = false;
    },
  },
});

export const {
  addOutreachStep,
  removeOutreachStep,
  applyPage,
  applySearchTerm,
  applySort,
  applyFilter,
  clearFilter,
  resetFilter,
  applyStep,
  removeStep,
} = actions;
export default reducer;
